var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.keywords)?_c('ul',{staticClass:"tags"},_vm._l((_vm.keywords),function(keyword){return _c('li',{key:keyword},[_c('a',{on:{"click":function($event){_vm.type === 'organisation' ? _vm.searchOrganisation(keyword)
         : _vm.type === 'recipe' ? _vm.searchRecipes(keyword)
         : _vm.type === 'ingredient' ? _vm.searchIngredients(keyword) : null}}},[_vm._v(_vm._s(keyword))])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65d495a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Keywords.vue
// module id = null
// module chunks = 